import type { TFunction } from "i18next";
import U2000DeleteRecordDialog from "../../../../u2000Core/components/dialog/U2000DeleteRecordDialog";

interface U3148OrganizationIconDeleteDlgProps {
  isOpen: boolean;
  onClose: (result: "yes" | "no") => void;
  t: TFunction;
  NS: string;
}

function U3148OrganizationIconDeleteDlg({ isOpen, onClose, t, NS }: U3148OrganizationIconDeleteDlgProps) {
  if (!isOpen) return null;

  return (
    <U2000DeleteRecordDialog isOpen={isOpen} onClose={onClose} title={t("lblDeleteDlgTitle", { ns: NS })}>
      <p className="mb-4">{t("msgDeleteIconConfirm", { ns: NS })}</p>
    </U2000DeleteRecordDialog>
  );
}

export default U3148OrganizationIconDeleteDlg;
